<template>
  <v-app>
    <v-main class="bg-img">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>
<style scoped lang="scss">
.bg-img {
  background-image: url("../src/assets/font/opt2.svg");
  background-color: #cccccc;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.full-size {
  height: 100% !important;
  width: 100% !important;
}

/* width */
::-webkit-scrollbar {
  width: 5px !important;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 1px grey !important;
  border-radius: 10px !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: cyan !important;
  border-radius: 10px !important;
}
</style>
